import { NgModule } from '@angular/core';
import { DisableContextMenuDirective } from './disable-context-menu.directive';
import { CxResizeObserverModule } from './resize-observer/resize-observer.module';

@NgModule({
  exports: [DisableContextMenuDirective, CxResizeObserverModule],
  declarations: [DisableContextMenuDirective],
})
export class DirectivesModule {}
